import { render } from "./RestoreBackup.vue?vue&type=template&id=8d72f2dc&ts=true"
import script from "./RestoreBackup.ts?vue&type=script&lang=ts&external"
export * from "./RestoreBackup.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__